import { useEffect, useState } from 'react'

export const useScroll = () => {
    const [scrollPosition, setPosition] = useState({ scrollX: 0, scrollY: 0 })

    useEffect(() => {
        function updatePosition() {
            if (window.location.origin.includes('localhost')) {
                setPosition({ scrollX: 0, scrollY: 0 })
            } else {
                setPosition({
                    scrollX: parseFloat(window.scrollY.toFixed(2)),
                    scrollY: parseFloat(window.scrollY.toFixed(2))
                })
            }
        }

        window.addEventListener('scroll', updatePosition)
        updatePosition()

        return () => window.removeEventListener('scroll', updatePosition)
    }, [])

    return scrollPosition
}